import { memo } from 'react';

interface IntegrationContainerProps {
  children: React.ReactNode;
}

/**
 * IntegrationContainer - Container component for integration lists
 *
 * Provides consistent styling and layout for integration item containers.
 * Used for both connected and available integration sections to maintain
 * visual consistency across the integrations page.
 *
 * @param {IntegrationContainerProps} props - Component props
 * @param {React.ReactNode} props.children - Child components to render inside the container
 * @returns {JSX.Element} The integration container component
 */
const IntegrationContainer = memo(({ children }: IntegrationContainerProps) => {
  return <div className="flex w-full flex-col items-stretch gap-3">{children}</div>;
});

IntegrationContainer.displayName = 'IntegrationContainer';

export default IntegrationContainer;
